<div class="ui-g form-container">
  <form [formGroup]='editforgotForm'>

    <div class="ui-g-12">
      <div class="form-field ui-g-12">
        <div class="form-label">
          <label for="username" id="ariaLabelEmail" translate>Username</label>
        </div>
        <div class="form-control">
          <input formControlName="email" id="email" aria-labelledby="ariaLabelEmail ariaLabelErrorEmail"
            aria-required="true" type="text" #emails pInputText appNoWhiteSpace />
        </div>
        <div class="form-errors" id="ariaLabelErrorEmail"
          *ngIf="editforgotForm.controls.email.errors  && (editforgotForm.controls.email.dirty || editforgotForm.controls.email.touched || submitted)">
          <div [hidden]="!editforgotForm.controls.email.errors.required" translate>
            email_required
          </div>
        </div>
      </div>
    </div>
    <div class="form-buttons ui-g-12 ui-g-nopad">
      <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel"
        (click)="closeEditForgot($event)"></button>
      <button pButton type="button" label="Save" icon="fa fa-check" (click)="changePassword($event)"></button>
    </div>
  </form>
</div>

<p-growl [value]="message"></p-growl>